<template>
	<div class="row contentblock">
		<div class="columns column6 col-image">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6 col-content">
			<div class="contentblock-content">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	padding: 0;
	margin: 75px auto;
	position: relative;
	z-index: 2;

	&:nth-child(even) {
		flex-direction: row-reverse;

		.col-image {
			left: 0;
			right: auto;
		}
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		padding: 0;
		position: relative;
		z-index: 2;
		width: 42%;
	}

	.col-image {
		position: relative;
		width: 58%;
	}

	.contentblock-content {
		padding: 50px 75px;

		h2,
		h3,
		:deep(h2),
		:deep(h3) {
			text-transform: uppercase;
			font-family: var(--body-font-family);
		}
	}
}

@media (max-width: 1380px) {
	.contentblock {
		h2 {
			font-size: 1.6em;
		}
	}
}

@media (max-width: 1180px) {
	.contentblock {
		h2 {
			font-size: 1.5em;
		}
	}
}

@media (max-width: 1080px) {
	.contentblock {
		margin: 50px auto;

		.col-image {
			width: 100%;
			position: relative;
		}

		.col-content {
			padding: 0;
			width: 100%;
			margin: 0 auto;
		}

		.contentblock-content {
			padding: 25px 40px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		h2 {
			font-size: 1.3em;
			letter-spacing: 0.5px;
		}

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
